import { getCurrentBranchName, getCurrentBranchPath } from 'app/branches/selectors';
import useRouter from 'app/common/hooks/use-router';
import { getProjectList } from 'app/project/actions';
import { getCurrentProjectId, getProjectJS, selectProjectList } from 'app/project/selectors';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useProjectMenu = () => {
  const dispatch = useDispatch();
  const currentProjectId = useSelector(getCurrentProjectId);
  const currentProject = useSelector(getProjectJS);
  const availableProjects = useSelector(selectProjectList);
  const branchName = useSelector(getCurrentBranchName);
  const branchPath = useSelector(getCurrentBranchPath);
  const { route } = useRouter();
  const activeProject = Boolean(currentProjectId);

  const [filterText, setFilterText] = useState('');

  useEffect(() => {
    if (activeProject && currentProject) {
      dispatch(getProjectList());
    }
  }, [activeProject, currentProject, dispatch]);

  // Reset filter on navigation
  // biome-ignore lint/correctness/useExhaustiveDependencies: intended
  useEffect(() => {
    setFilterText('');
  }, [route]);

  return { activeProject, currentProject, availableProjects, branchName, branchPath, filterText, setFilterText };
};

export type ProjectMenuProps = ReturnType<typeof useProjectMenu>;
